import type { NextRouter } from 'next/router';

export const isRouterReady = (router: Pick<NextRouter, 'isReady'>): boolean =>
  Boolean(router.isReady);
